import { IStage } from '@metservicedev/platforms-services-interface/src';
import React, { createContext, useContext, useMemo } from 'react';

export const PlatStageContext = createContext<{
    stage: IStage;
}>({
    stage: 'test',
});

export const discoverStage = (): IStage => {
    if (window.origin.includes('app.metoceanview-test.com')) return 'test';
    if (window.location.host.startsWith('test-insights.metservice.com')) return 'test';
    if (window.origin.includes('app.metoceanview-acceptance.com')) return 'acceptance';
    if (window.location.host.startsWith('uat-insights.metservice.com')) return 'acceptance';
    if (window.origin.includes('app.metoceanview.com')) return 'prod';
    if (window.location.host.startsWith('insights.metservice.com')) return 'prod';

    return 'test';
};

export const PlatStageProvider = ({ children, stage: _stage }: { children: React.ReactNode; stage?: IStage }) => {
    const stage = useMemo(() => _stage ?? discoverStage(), []);
    return <PlatStageContext.Provider value={{ stage }}>{children}</PlatStageContext.Provider>;
};

export const usePlatStageContext = () => useContext(PlatStageContext);
